import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HeaderInterceptor } from './header.interceptor';
import { LogInterceptor } from './log.interceptor';
import { UrlInterceptor } from './url.interceptor';

export const CUSTOM_INTERCEPTORS = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HeaderInterceptor,
    multi: true,
  }, {
    provide: HTTP_INTERCEPTORS,
    useClass: LogInterceptor,
    multi: true,
  }, /*{
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
  },*/{
    provide: HTTP_INTERCEPTORS,
    useClass: UrlInterceptor,
    multi: true,
  }
];
